<div class="pt-3 pb-5 dataset">
  <app-section-container [isCarausalAvailable]="false">
    <app-section-heading>
      <span class="text__black">{{ computeDetails.name || "NA" }}</span>
    </app-section-heading>
    <div>
      <app-section-description>
        <span class="text__black">
          {{ computeDetails.description || "NA" }}
          <span class="fw-700"> AIRAWAT.</span>
        </span>
      </app-section-description>
    </div>
    <div class="notebook-capabilities-flex">
      <ng-container
        *ngTemplateOutlet="
          infoCard;
          context: {
            imgSrc: 'images/direct-compute.svg',
            title: 'Direct Compute',
            desc: 'Access compute directly within your workspace',
          }
        "
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="
          infoCard;
          context: {
            imgSrc: 'images/train-models.svg',
            title: 'Train Models',
            desc: 'Train and evaluate AI models ',
          }
        "
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="
          infoCard;
          context: {
            imgSrc: 'images/AI-sol.svg',
            title: 'Ai Solutions',
            desc: 'Iterate and improve your models efficiently ',
          }
        "
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="
          infoCard;
          context: {
            imgSrc: 'images/Easy-collab.svg',
            title: 'Easy Collaboration',
            desc: 'Users can copy their artefact in the notebook environment',
          }
        "
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="
          infoCard;
          context: {
            imgSrc: 'images/explore-data.svg',
            title: 'Explore Data',
            desc: 'Explore structured and unstructured data',
          }
        "
      ></ng-container>
    </div>
    <div class="features-section">
      <h2 class="section-title mb-4">Usage Category</h2>
      <div class="row">
        <ng-container
          *ngTemplateOutlet="
            usageCard;
            context: {
              imgSrc: 'images/CPU.png',
              title: 'CPU ONLY',
              launchText: 'Launch CPU',
              desc: 'Perfect for learning and lightweight computations',
              cost: 'Free',
              features: [
                'Anytime CPU Access',
                'Basic Environment',
                '3.2 Core and 7GB RAM',
              ],
              backgroundColor: 'bg-cpu-basic-bg',
              showPoweredBy: false,
            }
          "
        ></ng-container>
        <ng-container
          *ngTemplateOutlet="
            usageCard;
            context: {
              imgSrc: 'images/Basic GPU.png',
              title: 'Basic GPU',
              launchText: 'Launch Basic GPU',
              desc: 'Ideal for moderate AI/ML experiments and training',
              cost: 'Free',
              features: [
                '4 Hours of GPU Access',
                'Advance Environment',
                '5 GB Profile of NVIDIA A100 GPU',
              ],
              backgroundColor: 'bg-gpu-basic-bg',
              showPoweredBy: true,
            }
          "
        ></ng-container>
        <ng-container
          *ngTemplateOutlet="
            usageCard;
            context: {
              imgSrc: 'images/Advance GPU.png',
              title: 'Advance GPU',
              launchText: 'Request Access',
              desc: 'Top grade performance for intensive workloads',
              cost: 'Free Requires Approval',
              features: [
                '22 Hours of GPU Access',
                'Priority Processing',
                '20 GB Profile of NVIDIA A100 GPU',
              ],
              backgroundColor: 'bg-gpu-advance-bg',
              showPoweredBy: true,
            }
          "
        ></ng-container>
      </div>
      <p class="mt-2">
        Need more GPU power for your AI workloads? Access high-performance
        compute resources on the
        <span class="text-primary cursor-pointer fw-600" (click)="openIndiaAI()"
          >INDIA AI Compute Platform
          <img class="ms-1" src="images/export-orange.svg" alt="External Link"
        /></span>
      </p>
    </div>
  </app-section-container>
</div>

<!-- Info Card ng-template with variable inputs -->
<ng-template #infoCard let-imgSrc="imgSrc" let-title="title" let-desc="desc">
  <div class="card-container">
    <div class="icon-wrapper">
      <img [src]="imgSrc" [alt]="title" />
    </div>
    <div class="title" [title]="title">{{ title }}</div>
    <div class="desc" [title]="desc">
      {{ desc }}
    </div>
  </div>
</ng-template>

<!-- Usage Card ng-template with variable inputs -->
<ng-template
  #usageCard
  let-features="features"
  let-imgSrc="imgSrc"
  let-title="title"
  let-cost="cost"
  let-desc="desc"
  let-launchText="launchText"
  let-backgroundColor="backgroundColor"
  let-showPoweredBy="showPoweredBy"
>
  <div class="col-12 col-lg-4 mb-3">
    <div
      class="usage-category"
      [ngClass]="[backgroundColor, showPoweredBy ? 'position-relative' : '']"
    >
      <div class="d-flex justify-content-start mb-2 gap-2 feature-container">
        <img height="66" width="66" [src]="imgSrc" [alt]="title" />
        <div>
          <div class="fw-600 text-lg mb-1">{{ title }}</div>
          <div class="fw-400 text-base category-desc" [title]="desc">
            {{ desc }}
          </div>
        </div>
      </div>
      <div class="tag-chip tag-chip-success my-3">{{ cost }}</div>
      <div>
        <ng-container *ngFor="let feature of features">
          <div class="mb-2 feature-line" [title]="feature">
            <img
              src="images/Checkmark Circle.png"
              height="20"
              width="20"
              alt=""
              class="me-2"
            />{{ feature }}
          </div>
        </ng-container>
      </div>
      <div
        class="powered-by"
        *ngIf="showPoweredBy"
        [ngClass]="{ 'position-absolute': showPoweredBy }"
      >
        <img src="images/powered-by-airawat-logo.svg" alt="" />
      </div>
      <div
        class="launch-btn mt-3 d-flex align-items-center justify-content-center gap-2 py-2"
        (click)="handleLaunchComputeBtn()"
      >
        <img src="images/view-all.svg" alt="Launch" />
        <span class="text-white fw-500 text-sm">{{ launchText }}</span>
      </div>
    </div>
  </div>
</ng-template>
